<template>
  <div class="rightmenu flex_content">
    <ul style="width: 200px;text-align: center">
      <li @mouseenter.stop="setAction(rightmenulist[1].type)" @mouseleave="setMouseleave()">
        <el-image style="width: 30px;height: 30px" class="imgli" :src="rightmenulist[1].img" />
        <div style="font-size: 16px;">APP下载</div>
        <div class="rit dow" v-if="action == 3">
          <el-image class="imgli" :src="rightmenulist[1].img2" />
        </div>
      </li>
      <li @mouseenter.stop="setAction(rightmenulist[0].type)" @mouseleave="setMouseleave()"
        @click="$router.push(supportLink)" :class="{ active: action == 2, hovered: isHovered }"
        @mouseover="isHovered = true" @mouseout="isHovered = false" style="cursor: pointer; transition: all 0.3s;">
        <el-image class="imgli" style="width: 30px;height: 30px" :src="rightmenulist[0].img" />
        <div style="font-size: 16px;">解决问题</div>
        <!-- <div class="rit phone" v-if="action == 2">
          <div style="margin-left: 20px">
            <div>
              <span style="display: inline-block;width: 100%;text-align: left;margin: 0px;padding: 0px">
                技术支持:
              </span>
              <span style="margin-left: 20px">
                0311-68007076
              </span>
            </div>
            <div>
              <span style="display: inline-block;width: 100%;text-align: left;margin: 0px;padding: 0px">
                工作时间:
              </span>
              <span style="margin-left: 20px">
                工作日
              </span>
              <br>
              <span style="margin-left: 20px">
                上午 8:30-11:30
              </span>
              <br>
              <span style="margin-left: 20px">
                下午 13:30-17:30
              </span>
            </div>
          </div>
        </div> -->
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  data() {
    return {
      action: 1,
      isHovered: false,
      supportLink: '/newsDetail?id=1880058996820283394', // 路由路径
      rightmenulist: [
        {
          type: 2,
          img: require('@@/assets/images/icon-dh.png'),
          img2: require('@@/assets/images/icon-dh2.png'),
        },
        {
          type: 3,
          img: require('@@/assets/images/icon-ewm2.png'),
          img2: require('@@/assets/images/apk_download.png'),
        },
        /*{
          type: 4,
          img: require('@@/assets/images/returntop.jpg'),
          img2: require('@@/assets/images/returntop.jpg')
        }*/
      ],
    };
  },
  methods: {
    setAction(type) {
      this.action = this.action == type ? '' : type;
      if (type == 4) {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      }
    },
    setMouseleave() {
      this.action = '';
    }
  }
};
</script>
<style lang="less" scoped>
ul,
li {
  padding: 0;
  margin: 0;
}

.rightmenu {
  width: 100px;
  position: fixed;
  right: 60px;
  bottom: 150px;
  align-items: flex-end;
  z-index: 99;

  li {
    position: relative;
    line-height: 30px;
  }

  /deep/ .el-image__inner {
    vertical-align: middle;
  }

  .rit {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateX(calc(-100% - 5px));
  }

  .gongzong {
    width: 100px;
    height: 130px;
    font-size: 12px;
    padding: 6px;
    background-color: #ffffff;
    text-align: center;
    // /deep/ .el-image{
    //     width: 60px;
    //     height: 60px;
    // }
  }

  .phone {
    margin-right: 20px;
    width: 250px;
    font-size: 18px;
    line-height: 34px;
    background-color: #ffffff;
    text-align: left;
    box-shadow: 0 1px 5px gray;
    border-radius: 20px;
  }

  .dow {
    margin-right: 20px;
    width: 250px;
    font-size: 18px;
    line-height: 34px;
    background-color: #ffffff;
    text-align: left;
    //box-shadow: 0 1px 5px gray;
    //border-radius: 20px;
  }

  p {
    font-size: 20px;
  }

  ul {
    //width: 40px;
    padding: 0;

    li {
      height: 80px;
      text-align: center;
      width: 80px;
      background-color: white;
      margin: 10px auto;
      border-radius: 5px;
      //margin-top: 13px;
      //line-height: 40px;
      font-size: 22px;
      border: 1px solid #e4e4e4;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &.hovered {
        background-color: #409EFF; // Element UI 蓝色
        border-color: #409EFF;
        color: white;

        .imgli.el-image .el-image__inner {
          filter: brightness(1.8); // 让图标更清晰
        }
      }

      &.active {
        background-color: #409EFF;
        border-color: #409EFF;
        color: white;

        .imgli.el-image .el-image__inner {
          filter: brightness(1.8);
        }
      }

      /deep/ .imgli.el-image {

        //width: 20px;
        //border: 1px solid #000;
        // height: 16px;
      }
    }
  }

  .img {
    width: 85px;
    height: 85px;
  }
}
</style>
